module.exports = __webpack_public_path__ + "static/media/supermarket_crop.598f4bf4.jpg";